
const TermsAndConditions = () => {
    window.location.replace('https://www.agrecalc.com/home/about/legal-documents/tcs-of-using-the-app/');
    return null;
}

export default TermsAndConditions